import { Fragment, useEffect, useRef, useState } from "react";
import { animated, useSpring } from "react-spring";

export default function ParalaxElement({ title, content, ev, id }) {
  const { hovered, eventHandlers } = ev;
  const [isHovered, setIsHovered] = useState(false);
  const contentRef = useRef();
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (!contentRef) return;
    setHeight(contentRef.current.offsetHeight);
  }, [setHeight]);

  useEffect(() => {
    setIsHovered(parseInt(hovered) === parseInt(id));
  }, [hovered, setIsHovered, id]);

  const styles = useSpring({
    transform: isHovered ? "translateY(0px)" : "translateY(200px)",
    height: isHovered ? `${height+1}px` : "0px",
    opacity: isHovered ? 1 : 0,
    // delay: 1000,
    config: {
      duration: 500,
    },
  });

  return (
    <Fragment>
      <div className={`paralax__element${isHovered ? " active" : ""}`}>
        <h1 className="d-flex mx-auto" {...eventHandlers} id={id}>
          {title}
        </h1>
        <animated.div style={styles} className="paralax__content">
          <span
            ref={contentRef}
            className="fs-bigBody pb-5 pt-1 d-flex justify-content-center align-content-center text-center flex-column"
          >
            {content}
          </span>
        </animated.div>
      </div>
    </Fragment>
  );
}
